import './ClearFilter.css';
const ClearFilter = ({ onClear }) => {
  const handleClear = () => {
    onClear();
  };
  return (
    <button onClick={handleClear} className="clear-filter-btn">
      Clear Filters
    </button>
  );
};


export default ClearFilter;